import { Input } from 'antd'
import InfoCircle from '../../svgs/InfoCircle'

export default function InputNormal({
  label,
  placeholder,
  hint,
  name,
  disabled,
  prefix,
  value,
  onChange,
  error,
  style,
}) {
  return (
    <div className={`input ${style ? style : ''}`}>
      {label && (
        <div className='flex justify-between'>
          <label className='flex items-center gap-8' htmlFor={name}>
            {label}{' '}
            <InfoCircle style={!error ? 'opacity-0' : ''} color='#D93F21' />
          </label>
        </div>
      )}
      <Input
        id={name}
        name={name}
        prefix={prefix}
        disabled={disabled}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      {hint && <p className='text-[#AAA] text-sm mt-8 mb-0'>{hint}</p>}
      <p className='text-danger text-xs mt-4 mb-0'>{error}</p>
    </div>
  )
}
